import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Button } from '@src/elements/button/button'
import QrCode from '@src/routes/members/components/account/qr-code'

@Component({
  computed: {
    codeSerial () {
      return this.$store.state.memberProfile.codeSerial || ''
    },
    codeNumber () {
      return this.$store.state.memberProfile.codeNumber || ''
    }
  }
})
export default class PrintQrCode extends QrCode {

  protected codeSerial: string
  protected codeNumber: string

  constructor () {
    super()
  }

  renderActionButtons (h: CreateElement) {
    return <div class='btn-row' slot='bottom'>
      <Button class='print-qr' type='remove' click={this.printQR} ref='printQrBtn' icon={'util/print'} label={this.$t('PRINT')} />
    </div>
  }
}
